





































import { defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { TranslateResult } from "vue-i18n";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import providers from "@/lib/api";
import { userWithAvatarFields } from "@/lib/fieldsHelper";
import { $t } from "@/lib/i18nHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import ListItem from "@/components/ListItem";
import RichTextarea from "@/components/RichTextarea";

export default defineComponent({
  name: "InputWithMentions",
  components: { RichTextarea, BaseSpinner, ListItem, BaseAvatar, CustomScroll },
  props: {
    value: { type: String, required: true },
    placeholder: { type: String as PropType<TranslateResult>, default: $t("Caption") },
  },
  setup(props, ctx) {
    const showList = ref(false);
    const loading = ref(false);
    const users = ref<UserPublicData[]>([]);
    const inputFocus = ref<() => void>(() => {});

    const getUsers = debounce(async (stringAfterAt: string) => {
      try {
        users.value = await providers.UserPublicDataProvider.relevantSearchByName(
          {
            name: stringAfterAt,
            topRole: "creator",
          },
          userWithAvatarFields({ onlineStatus: false })
        );
      } finally {
        if (users.value.length === 0) {
          showList.value = false;
        }
        loading.value = false;
      }
    }, 500);

    watch(toRef(props, "value"), async newValue => {
      const splitText = newValue.split(/[ \n\t\r]/);
      const lastWord = splitText[splitText.length - 1];
      if ((lastWord.startsWith("@") || lastWord.startsWith("＠")) && lastWord.length > 1) {
        const stringAfterAt = lastWord.substring(1);
        showList.value = true;
        loading.value = true;
        await getUsers(stringAfterAt);
      } else {
        getUsers.cancel();
        users.value = [];
        showList.value = false;
        loading.value = false;
      }
    });

    const insertMention = (selectedUsername: string) => {
      const splitText = props.value.split(/[ \n\t\r]/);
      const inputUserName = splitText[splitText.length - 1].substring(1);
      const result = props.value.slice(0, props.value.length - inputUserName.length);
      ctx.emit("input", `${result}${selectedUsername} `);
      inputFocus.value();
    };

    const defineFocus = (cb: () => void) => {
      inputFocus.value = cb;
    };

    return { showList, loading, users, insertMention, defineFocus, resolveUserName };
  },
});
